var map = {
	"./AISpace2-vis.mp4": "06cd",
	"./AISpace2.jpg": "649f",
	"./AMZPark.jpg": "22df",
	"./BrewOL.jpg": "e5b1",
	"./BrewOL2.jpg": "24c9",
	"./ChatSim.jpg": "1912",
	"./UBCTanTan.jpg": "dcf9",
	"./VanExposure.jpg": "a9b7"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "cc1f";